import Tdg_OrganisationUpdateModelBase from '../_generated/modelBases/tdg-organisation-update-model-base';

export default class Tdg_OrganisationUpdateModel extends Tdg_OrganisationUpdateModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
